module.exports = __webpack_public_path__ + "img/ai_key.407b0263.png";